import { InfoOutlined as InfoIcon } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { CustomTooltip } from 'src/components/tooltip/CustomTooltip';
import { lang } from 'src/utils';

export interface AdvancedSettingsInfoTooltipProps {
  isGlobalSettingEnabled?: boolean;
  /** When set, overrides the default tooltip title (used for Section Rotation/Takeover disabled message). */
  titleOverride?: string;
}

export const AdvancedSettingsInfoTooltip = ({
  isGlobalSettingEnabled = true,
  titleOverride,
}: AdvancedSettingsInfoTooltipProps) => {
  const title =
    titleOverride ??
    (isGlobalSettingEnabled
      ? lang.assemblyLayouts.advancedSettings.notAvailableWarning
      : lang.assemblyLayouts.advancedSettings.enableCustomerTriggerEventsInfo);

  return (
    <CustomTooltip
      placement="top"
      width={500}
      skipValidateOverflow
      title={title}>
      <IconButton disableRipple>
        <InfoIcon />
      </IconButton>
    </CustomTooltip>
  );
};
